// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cw-2";
export var aiChatCartContainerExit = "_cw-4";
export var aiChatContainerLarge = "_cw-0";
export var aiChatContainerSmall = "_cw-1";
export var aiChatIcon = "_cw-6";
export var slideInFromRight = "_cw-3";
export var slideOutToRight = "_cw-5";